var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "check_grey",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .check_grey .a{fill:#fff;stroke-width:2px;}.check_grey .a,.check_grey .b{stroke:#d8d8d8;}.check_grey .b,.check_grey .d{fill:none;}.check_grey .b{stroke-linecap:round;stroke-width:3px;}.check_grey .c{stroke:none;}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-544 -435)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(544 435)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 15.5,
    cy: 15.5,
    r: 14.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M593.5,448.268l3.8,3.915L605.489,444",
    transform: "translate(-40.003 2.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGrey);
export default __webpack_public_path__ + "static/media/check_grey.01aff9c9.svg";
export { ForwardRef as ReactComponent };